import React, { useState } from "react";
import "../../style/Selectable.css";

function Selectable() {
  const [activeTab, setActiveTab] = useState("list");
  const [selected, setSelected] = useState(null);

  const listItems = [
    "It is a long established fact that a reader will be distracted",
    "Many desktop publishing packages and web page editors now",
    "sometimes by accident, sometimes on purpose (injected humour and the like)",
    "Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia",
    "The first line of Lorem Ipsum comes from section 1.10.32",
    "The first line of Lorem Ipsum comes from section 1.10.32"
  ];

  const gridItems = [1,2,3,4,5,6];

  return (
    <div className="selectable-container col-md-8 col-lg-8 col-xl-8">

      <h1 className="mb-3 fw-normal border-bottom text-left pb-2 mb-4">
        Selectable
      </h1>

      {/* Tabs */}

      <div className="nav nav-tabs">
        <button
          className={`nav-link ${activeTab === "list" ? "active" : ""}`}
          onClick={() => setActiveTab("list")}
        >
          List
        </button>

        <button
          className={`nav-link ${activeTab === "grid" ? "active" : ""}`}
          onClick={() => setActiveTab("grid")}
        >
          Grid
        </button>
      </div>

      {/* List View */}

      {activeTab === "list" && (
        <ul className="list-group rounded mt-4">

          {listItems.map((item, index) => (
            <li
              key={index}
              className={`list-group-li ${
                selected === index ? "active" : ""
              }`}
              onClick={() => setSelected(index)}
            >
              {item}
            </li>
          ))}

        </ul>
      )}

      {/* Grid View */}

      {activeTab === "grid" && (
        <ul className="list-group rounded mt-4 box-wrap">

          {gridItems.map((item, index) => (
            <li
              key={index}
              className={`list-group-li list-group-box ${
                selected === index ? "active" : ""
              }`}
              onClick={() => setSelected(index)}
            >
              {item}
            </li>
          ))}

        </ul>
      )}

    </div>
  );
}

export default Selectable;